(function() {
    function setupAnchorTabs(workoutContainer) {
        const tabs = workoutContainer.querySelectorAll('.header-nav .tab');
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
            });
        });
    }
function setupConditionalBackArrow() {
        const backButton = document.getElementById('conditional-back-button');
        const referrer = document.referrer;
        const currentHost = window.location.hostname;

        // Check if a referrer exists and if its hostname matches the current site's hostname.
        if (backButton && referrer && (new URL(referrer)).hostname === currentHost) {
            // If the user came from another page on our site, show the back button.
            backButton.style.display = 'block';
        }
    }
   function setupVideoPlayer(workoutContainer) {
        const controlsContainer = workoutContainer.querySelector('.workout-controls');
        const videoInfoOverlay = workoutContainer.querySelector('.video-info-overlay-wrapper'); // Get the badge container

        if (!controlsContainer || !videoInfoOverlay) return;

        controlsContainer.addEventListener('click', (e) => {
            const button = e.target.closest('button');
            if (!button) return;

            controlsContainer.querySelectorAll('button').forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            const tabKey = button.dataset.tabKey;

            // --- LOGIC TO HIDE/SHOW BADGES ---
            if (tabKey === 'workout') {
                videoInfoOverlay.style.display = 'flex'; // Show the badges
            } else {
                videoInfoOverlay.style.display = 'none'; // Hide the badges
            }
            // --- END OF LOGIC ---

            const videoContentContainer = workoutContainer.querySelector('.video-embed-container');
            if (videoContentContainer) {
                videoContentContainer.querySelectorAll('.video-tab-content').forEach(content => content.classList.remove('active'));
                const activeContent = videoContentContainer.querySelector(`.video-tab-content#${tabKey}`);

                if (activeContent) {
                    // Lazy-load the video if the tab is empty
                    if (activeContent.innerHTML.trim() === '' && activeContent.dataset.embedCode) {
                        activeContent.innerHTML = activeContent.dataset.embedCode;
                    }
                    activeContent.classList.add('active');
                }
            }
        });
    }
function setupVideoOverlayHiding(workoutContainer) {
        const videoPlayer = workoutContainer.querySelector('.video-player');
        const videoInfoOverlayWrapper = workoutContainer.querySelector('.video-info-overlay-wrapper');

        if (videoPlayer && videoInfoOverlayWrapper) {
            videoPlayer.addEventListener('click', () => {
                videoInfoOverlayWrapper.style.transition = 'opacity 0.3s ease';
                videoInfoOverlayWrapper.style.opacity = '0';
                setTimeout(() => {
                    videoInfoOverlayWrapper.style.display = 'none';
                }, 300);
            }, { once: true });
        }
    }
    function setupClassPlanSlider(workoutContainer) {
        const classPlanCard = workoutContainer.querySelector('#class-plan');
        if (!classPlanCard) return;

        const sliderContainer = classPlanCard.querySelector('.slider-container');
        const sliderWrapper = classPlanCard.querySelector('.slider-wrapper');
        const slides = classPlanCard.querySelectorAll('.circuit-slide');
        const dotsContainer = classPlanCard.querySelector('.slider-dots');
        const prevButton = classPlanCard.querySelector('#prev-circuit');
        const nextButton = classPlanCard.querySelector('#next-circuit');

        if (!slides || slides.length <= 1) {
            if (dotsContainer) dotsContainer.style.display = 'none';
            const navContainer = classPlanCard.querySelector('.circuit-nav-buttons');
            if (navContainer) navContainer.style.display = 'none';
            return;
        }

        dotsContainer.innerHTML = Array.from(slides).map((_, index) => `<span class="dot ${index === 0 ? 'active' : ''}" data-index="${index}"></span>`).join('');
        const dots = classPlanCard.querySelectorAll('.dot');
        let currentIndex = 0;

        function updateButtonStates() {
            if (prevButton) prevButton.disabled = currentIndex === 0;
            if (nextButton) nextButton.disabled = currentIndex === slides.length - 1;
        }

        function goToSlide(index) {
            index = Math.max(0, Math.min(index, slides.length - 1));
            if (sliderWrapper) sliderWrapper.style.transform = `translateX(-${index * 100}%)`;
            if (dots.length > 0) {
                dots.forEach(dot => dot.classList.remove('active'));
                if (dots[index]) {
                    dots[index].classList.add('active');
                }
            }
            currentIndex = index;
            updateButtonStates();
        }

        goToSlide(0);
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => goToSlide(index));
        });

        if (prevButton) {
            prevButton.addEventListener('click', () => goToSlide(currentIndex - 1));
        }
        if (nextButton) {
            nextButton.addEventListener('click', () => goToSlide(currentIndex + 1));
        }

        let touchstartX = 0;
        sliderContainer.addEventListener('touchstart', e => {
            touchstartX = e.changedTouches[0].screenX;
        }, { passive: true });
        
        sliderContainer.addEventListener('touchend', e => {
            const touchendX = e.changedTouches[0].screenX;
            const deltaX = touchendX - touchstartX;
            const swipeThreshold = 50;

            if (Math.abs(deltaX) > swipeThreshold) {
                if (deltaX < 0) {
                    // Swiped left (next)
                    goToSlide(currentIndex + 1);
                } else {
                    // Swiped right (previous)
                    goToSlide(currentIndex - 1);
                }
            }
        }, { passive: true });

        updateButtonStates();
    }

   function setupMusicWidget(workoutContainer) {
                const musicWidget = workoutContainer.querySelector('.music-widget');
                const musicFab = workoutContainer.querySelector('#music-fab');
                const infoButton = workoutContainer.querySelector('#music-info-button');
                if (!musicWidget || !musicFab) return;
                const playlistSelector = workoutContainer.querySelector('#playlist-selector');
                const musicEmbed = workoutContainer.querySelector('#music-embed');

                const musicPlaylists = [
                    { name: 'Electronic', url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/soundcloud%253Aplaylists%253A253311446&color=%2300bcd4&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true' },
                    { name: 'Relaxing Yoga', url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/soundcloud%253Aplaylists%253A292330672&color=%2300bcd4&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true' },
                    { name: 'Beast Mode Dance', url: 'https://open.spotify.com/embed/playlist/37i9dQZF1DXdURFimg6Blm?utm_source=generator' },
                    { name: 'Beast Mode', url: 'https://open.spotify.com/embed/playlist/37i9dQZF1DX76Wlfdnj7AP?utm_source=generator' },
                    { name: 'Fun Workout Mix', url: 'https://open.spotify.com/embed/playlist/37i9dQZF1EIdBKZUQJyqDm?utm_source=generator' },
                    { name: 'Workout Rock Mix', url: 'https://open.spotify.com/embed/playlist/37i9dQZF1EIdy7dVdne3kM?utm_source=generator' },
                    { name: 'Workout', url: 'https://open.spotify.com/embed/playlist/37i9dQZF1DX70RN3TfWWJh?utm_source=generator' },
                    { name: '2000s Workout Mix', url: 'https://open.spotify.com/embed/playlist/37i9dQZF1EIcBvJ5NboF6b?utm_source=generator' },
                    { name: 'Reggaeton Mix', url: 'https://open.spotify.com/embed/playlist/37i9dQZF1EIfMwYwZVNWIr?utm_source=generator' },
                ];

                if (playlistSelector && musicEmbed) {
                    playlistSelector.innerHTML = musicPlaylists.map(p => `<option value="${p.url}">${p.name}</option>`).join('');
                    // The line that set the initial src is now removed
                    playlistSelector.addEventListener('change', (e) => {
                        musicEmbed.src = e.target.value;
                    });
                }

                musicFab.addEventListener('click', () => {
                    // --- NEW LAZY-LOADING LOGIC ---
                    // On the first click, check if the player is blank
                    if (musicEmbed.getAttribute('src') === 'about:blank') {
                        // If it is, load the player by setting the src from our data attribute
                        musicEmbed.src = musicEmbed.dataset.src;
                    }
                    // --- END OF NEW LOGIC ---

                    musicWidget.classList.toggle('active');
                });

                if (infoButton) {
                    infoButton.addEventListener('click', () => {
                        alert('You may need to play the video then the music. For Spotify, full songs require a Premium account and being logged in on this browser. Previews will play for all other users. Spotify works best on Chrome for desktop but may work for other devices too.');
                    });
                }
            }
function setupEquipmentBadge(workoutContainer) {
        const overlayWrapper = workoutContainer.querySelector('.video-info-overlay-wrapper');
        const equipmentBadgeWrapper = workoutContainer.querySelector('.equipment-badge-wrapper');

        if (!overlayWrapper || !equipmentBadgeWrapper || !overlayWrapper.dataset.tags) return;

        try {
            const tags = JSON.parse(overlayWrapper.dataset.tags);
            const equipmentList = [];

            tags.forEach(tag => {
                if (tag.toLowerCase().includes('equipment_')) {
                    let equipmentName = tag.substring(tag.indexOf('_') + 1);
                    equipmentName = equipmentName.replace(/[-_]/g, ' ');
                    equipmentName = equipmentName.charAt(0).toUpperCase() + equipmentName.slice(1);
                    equipmentList.push(equipmentName);
                }
            });

            if (equipmentList.length > 0) {
                equipmentList.forEach(equipmentString => {
                    const badge = document.createElement('div');
                    badge.className = 'info-badge';
                    // UPDATED: The icon span is now removed from this line
                    badge.innerHTML = `<span>${equipmentString}</span>`;
                    equipmentBadgeWrapper.appendChild(badge);
                });
            }
        } catch (e) {
            console.error('Error parsing product tags for equipment badge:', e);
        }
    }
    function setupShareModal(workoutContainer) {
        const shareButton = workoutContainer.querySelector('#share-button');
        const modalOverlay = workoutContainer.querySelector('.share-modal-overlay');
        const closeModalButton = workoutContainer.querySelector('#share-modal-close');

        if (!shareButton || !modalOverlay || !closeModalButton) {
            return;
        }

        const shareData = {
            title: document.title,
            text: 'Check out this awesome workout!',
            url: window.location.href
        };

        const shareUrls = {
            facebook: `https://www.google.com/search?q=https://open.spotify.com/embed/playlist/37i9dQZF1DX76Wlfdnj7AP%3Futm_source%3Dgenerator0`,
            twitter: `https://open.spotify.com/embed/playlist/37i9dQZF1DX76Wlfdnj7AP?utm_source=generator2`,
            pinterest: `https://open.spotify.com/embed/playlist/37i9dQZF1DX76Wlfdnj7AP?utm_source=generator3`,
            linkedin: `https://open.spotify.com/embed/playlist/37i9dQZF1DX76Wlfdnj7AP?utm_source=generator4`,
            reddit: `https://open.spotify.com/embed/playlist/37i9dQZF1DX76Wlfdnj7AP?utm_source=generator5`,
            whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareData.text)}%20${encodeURIComponent(shareData.url)}`,
            telegram: `https://t.me/share/url?url=${encodeURIComponent(shareData.url)}&text=${encodeURIComponent(shareData.text)}`,
            email: `mailto:?subject=${encodeURIComponent(shareData.title)}&body=${encodeURIComponent(shareData.text)}%20${encodeURIComponent(shareData.url)}`
        };

        const shareLinks = modalOverlay.querySelectorAll('[data-social]');
        shareLinks.forEach(link => {
            const platform = link.dataset.social;
            if (shareUrls[platform]) {
                link.href = shareUrls[platform];
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
            }
        });

        function openModal() { modalOverlay.classList.add('active'); }
        function closeModal() { modalOverlay.classList.remove('active'); }

        closeModalButton.addEventListener('click', closeModal);
        modalOverlay.addEventListener('click', e => {
            if (e.target === modalOverlay) closeModal();
        });

        shareButton.addEventListener('click', async () => {
            if (/Mobi|Android/i.test(navigator.userAgent) && navigator.share) {
                try {
                    await navigator.share(shareData);
                } catch (err) {
                    if (err.name !== 'AbortError') { openModal(); }
                }
            } else {
                openModal();
            }
        });
    }


function setupVideoFacade(workoutContainer) {
    const videoPlayer = workoutContainer.querySelector('.video-player');
    if (!videoPlayer) return;

    videoPlayer.addEventListener('click', function(event) {
        const facade = event.target.closest('.video-facade');
        if (!facade) return;
        const videoPlayer = facade.closest('.video-player');
        if (videoPlayer) {
          // Find the overlay inside that section
          const overlay = videoPlayer.querySelector('.video-info-overlay-wrapper');
          // Add our class to hide it
          if (overlay) {
            overlay.classList.add('is-hidden');
          }
        }

        event.stopImmediatePropagation();

        const videoId = facade.dataset.videoId;
        const videoType = facade.dataset.videoType;

        if (!videoId || !videoType) return;
        
        if (videoType === 'youtube') {
            const iframe = document.createElement('iframe');
            // FIX: Added autoplay=1 to the URL
            iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            iframe.setAttribute('allowfullscreen', '');
            
            facade.parentNode.replaceChild(iframe, facade);
        
        } else if (videoType === 'jwplayer') {
            const playerContainerId = `jwplayer-container-${videoId}`;
            const playerContainer = document.createElement('div');
            playerContainer.id = playerContainerId;

            facade.parentNode.replaceChild(playerContainer, facade);

            jwplayer(playerContainerId).setup({
                playlist: [{
                    file: `https://cdn.jwplayer.com/manifests/${videoId}.m3u8`,
                    image: facade.querySelector('img')?.src || ''
                }],
                width: "100%",
                aspectratio: "16:9",
                autostart: true // FIX: Added autostart for JW Player
            });
        }
    }, { capture: true });
}
    function initializeApp() {
        const workoutContainer = document.getElementById('hiit-workout-template');
        if (!workoutContainer || workoutContainer.dataset.initialized === 'true') {
            return;
        }
        workoutContainer.dataset.initialized = 'true';
        setupAnchorTabs(workoutContainer);
        setupVideoPlayer(workoutContainer);
        setupClassPlanSlider(workoutContainer);
        setupMusicWidget(workoutContainer);
        setupShareModal(workoutContainer);
        setupVideoOverlayHiding(workoutContainer);
        setupEquipmentBadge(workoutContainer);
        setupConditionalBackArrow();
        setupVideoFacade(workoutContainer);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeApp);
    } else {
        initializeApp();
    }
})();